import { render, staticRenderFns } from "./en.vue?vue&type=template&id=c8e70738&"
import script from "./en.vue?vue&type=script&lang=js&"
export * from "./en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports